export default __webpack_public_path__ + "static/media/_IMG7502.22482b06.jpg";